<template lang="pug">
.container-editar-perfil
  .header
    Tabs(:tabs="tabs" @change="handleTabChange")
  .paginas
    router-view
</template>

<script>
import Tabs from '@/components/ui/Tabs.vue'

export default {
  name: 'EditarPerfil',
  components: {
    Tabs
  },
  data() {
    return {
      tabs: [
        {
          label: 'Informações Pessoais',
          icon: { component: 'LucideIcon', name: 'User', size: 16 },
          rota: 'informacoes-pessoais'
        },
        {
          label: 'Top Habilidades',
          icon: { component: 'LucideIcon', name: 'Star', size: 16 },
          rota: 'top-habilidades'
        },
        {
          label: 'Todas Habilidades',
          icon: { component: 'LucideIcon', name: 'Layers', size: 16 },
          rota: 'outras-habilidades'
        }
      ]
    }
  },
  methods: {
    handleTabChange(index) {
      const rotaDestino = this.tabs[index].rota
      if (this.$route.path !== `/espaco-nexa/editar-perfil/${rotaDestino}`) {
        this.$router.push(`/espaco-nexa/editar-perfil/${rotaDestino}`)
      }
    }
  },

  async created() {
    try {
      await this.$store.dispatch('classes/fetchClasses')
    } catch (error) {
      console.error('Erro ao carregar dados:', error)
    }
  }
}
</script>

<style lang="scss">
.container-editar-perfil {
  .header {
    margin-bottom: 25px;
  }
}
</style>
